import "./App.css";
import AllRoutes from "./routes/allRoutes";
import { LoaderProvider } from "./contexts/LoaderContext";
import PageLoader from "./components/PageLoader";

function App() {
  return (
    <LoaderProvider>
      <PageLoader />
      <AllRoutes />
    </LoaderProvider>
  );
}

export default App;
